// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"t2l9FDXv"};